var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from "react";
import styled from "styled-components";
import { Typography } from "../../../index";

var Link = function Link(_ref) {
  var navAtTop = _ref.navAtTop,
      displayName = _ref.displayName;
  return React.createElement(
    Typography,
    {
      $as: "span",
      size: 1,
      color: navAtTop ? "primary" : "navPrimary",
      bold: true,
      style: { margin: "0 1em", display: "flex", alignItems: "center" }
    },
    displayName
  );
};

export var MenuLinksDesktop = function MenuLinksDesktop(_ref2) {
  var wrapLink = _ref2.wrapLink,
      navAtTop = _ref2.navAtTop,
      menuContent = _ref2.menuContent;

  return React.createElement(
    MenuLinks,
    null,
    menuContent.links.filter(function (link) {
      return link.showOnDesktop;
    }).map(function (linkProps, i) {
      var linkContent = React.createElement(Link, _extends({ key: i }, linkProps, { navAtTop: navAtTop }));
      return wrapLink(linkContent, linkProps);
    })
  );
};

var MenuLinks = styled.div.withConfig({
  displayName: "MenuLinksDesktop__MenuLinks",
  componentId: "sc-10aqpsj-0"
})(["display:flex;margin-right:1em;"]);